var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkFilled = function SvgBookmarkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 7v29l-12-7-12 7V7a3 3 0 0 1 3-3h18c1.625 0 3 1.375 3 3"
  })));
};
export default SvgBookmarkFilled;